export default __webpack_public_path__ + "static/12-cebba7ba6705823a7a365918b5c1ff37.jpg";